/**
 * Slice "manualPayloads" dello state Pinia del promo-engine.
 * Mantiene i payload e ultimi risultati
 * relativi ai flussi MANUAL (estimate/apply/confirm).
 */

import { PromoPayload, PromoItem, PromoOutput } from '../../types'

export type ManualPayloadsState = {
  manualPromoList: any[] // aggiornare con api corretta ESTIMATE
  consumerCampaigns: any[] // aggiornare con api corretta consumerCampaigns
  currentManualPreview: {
    items: PromoItem[]
    costs: any[]
    promo: any[]
  }
  manualModalShown: boolean
  currentEstimate: {
    input: PromoPayload | null
    output: PromoOutput | null
    rule_engine_version: string | null
    maxed_out_promotions: unknown
  }
  fidelityRecap: unknown
  saleDatiAggiuntivi: unknown
}

export const createManualPayloadsState = (): ManualPayloadsState => ({
  manualPromoList: [],
  consumerCampaigns: [],
  currentManualPreview: {
    items: [],
    costs: [],
    promo: [],
  },
  manualModalShown: false,
  currentEstimate: {
    input: null,
    output: null,
    rule_engine_version: '',
    maxed_out_promotions: {},
  },
  fidelityRecap: null,
  saleDatiAggiuntivi: null,
})
